let page_schema = {
    "tiers": [
        {
            "name": "d-none",
            "type": "checkbox",
            "id": "d-none",
            "class_name": "tags",
            "child_name": "d-none",
            "options": [
                {
                    "name": "Nucleic Acid Purification",
                    "id": "nucleic-acid-purification"
                },
                {
                    "name": "Genomic DNA",
                    "id": "genomic-dna"
                },
                {
                    "name": "Yeast Transformation",
                    "id": "yeast-transformation"
                },
                {
                    "name": "Yeast Reagents and Enzymes",
                    "id": "yeast-reagents-and-enzymes"
                },
                {
                    "name": "Yeast Mating Pheromones",
                    "id": "yeast-mating-pheromones"
                },
                {
                    "name": "Quick-DNA Fungal Bacterial Kits",
                    "id": "quick-dna-fungal-bacterial-kits"
                },
                {
                    "name": "Yeast",
                    "id": "yeast"
                }
            ]
        }
    ],
    "filters": [],
    "products": {
        "Zymolyase Ultra": {
            "title": "Zymolyase Ultra",
            "catalogNumbers": "E1007T, E1007-2, E1007-10",
            "description": "An optimized enzyme formulation for efficient yeast cell wall digestion, targeting multiple wall components. It is highly purified with DNA/RNA removal technology to deliver ultra-low nucleic acid contamination.",
            "handle": "/products/zymolyase-ultra",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/files/E1007T-Zymolyase-100-U_a70918fd-fa44-4b59-b2a4-7cb354961c54_5760x5760.jpg?v=1713477194",
            "generalIndex": "998",
            "id": "zymolyase-ultra",
            "tags": [
                "yeast"
            ],
            "filters": []
        },
        "Frozen-EZ Yeast Transformation II Kit": {
            "title": "Frozen-EZ Yeast Transformation II Kit",
            "catalogNumbers": "T2001",
            "description": "The Frozen-EZ Yeast Transformation II Kit is designed to make yeast transformations and library screening easier and more efficient than currently available methods.",
            "handle": "/products/frozen-ez-yeast-transformation-ii-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T2001_Frozen-EZ-Yeast-Transformation-II-Kit_a3b6e0a9-2ff0-46d3-befa-66d78d61af9b.jpg?v=1628532360&width=600",
            "generalIndex": "998",
            "id": "frozen-ez-yeast-transformation-ii-kit",
            "tags": [
                "yeast",
                "yeast-transformation"
            ],
            "filters": []
        },
        "Zymolyase": {
            "title": "Zymolyase",
            "catalogNumbers": "E1004, E1005, E1006",
            "description": "Digestion of yeast and fungal cell walls is necessary for many experimental procedures including spheroplasting, immunofluorescence, transformation, protein purification, and others.",
            "handle": "/products/zymolyase",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E1005_Zymolayse-2000-U_d0db7f0b-6855-496b-bec6-e1d916a0bbf5.jpg?v=1628532375&width=600",
            "generalIndex": "998",
            "id": "zymolyase",
            "tags": [
                "yeast",
                "yeast-reagents-and-enzymes"
            ],
            "filters": []
        },
        "Zymoprep Yeast Plasmid Miniprep I": {
            "title": "Zymoprep Yeast Plasmid Miniprep I",
            "catalogNumbers": "D2001",
            "description": "The Zymoprep Yeast Plasmid Miniprep I is a simple and efficient yeast plasmid miniprep that is based on the E. coli alkaline lysis method but using Zymolyase as the first solution.",
            "handle": "/collections/zymoprep-yeast-plasmid-miniprep/products/zymoprep-yeast-plasmid-miniprep-i",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit_8b5581ce-6473-43b0-951d-d8f0a01bd259.jpg?v=1628532359&width=600",
            "generalIndex": "998",
            "id": "zymoprep-yeast-plasmid-miniprep-i",
            "tags": [
                "yeast",
                "nucleic-acid-purification"
            ],
            "filters": []
        },
        "Zymoprep Yeast Plasmid Miniprep II": {
            "title": "Zymoprep Yeast Plasmid Miniprep II",
            "catalogNumbers": "D2004",
            "description": "The Zymoprep Yeast Plasmid Miniprep II is a simple and efficient yeast plasmid miniprep that is based on the E. coli alkaline lysis method but using Zymolyase as the first solution.",
            "handle": "/collections/zymoprep-yeast-plasmid-miniprep/products/zymoprep-yeast-plasmid-miniprep-ii",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D2004_Zymoprep-Yeast-Plasmid-MiniPrep-II-Kit_aabbe60a-e5fb-44a8-b7b4-722047f23e24.jpg?v=1628532377&width=600",
            "generalIndex": "998",
            "id": "zymoprep-yeast-plasmid-miniprep-ii",
            "tags": [
                "yeast",
                "nucleic-acid-purification"
            ],
            "filters": []
        },
        "Zymoprep-96 Yeast Plasmid Miniprep": {
            "title": "Zymoprep-96 Yeast Plasmid Miniprep",
            "catalogNumbers": "D2005, D2006, D2007",
            "description": "Easy high-throughput spin-column purification of plasmid DNA from yeast cultures using Zymolyase and alkaline lysis.",
            "handle": "/products/zymoprep-96-yeast-plasmid-miniprep",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D2007_Zymoprep-96-Yeast-Plasmid-Miniprep-Kit_815aae83-fc83-4806-8e72-654cdf122053.jpg?v=1628532360&width=600",
            "generalIndex": "998",
            "id": "zymoprep-96-yeast-plasmid-miniprep",
            "tags": [
                "yeast",
                "nucleic-acid-purification"
            ],
            "filters": []
        },
        "YeaStar Genomic DNA Kit": {
            "title": "YeaStar Genomic DNA Kit",
            "catalogNumbers": "D2002",
            "description": "Reliable and efficient isolation of genomic DNA from a broad spectrum of fungal species using Zymolyase.",
            "handle": "/products/yeastar-genomic-dna-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D2002.jpg",
            "generalIndex": "998",
            "id": "yeastar-genomic-dna-kit",
            "tags": [
                "yeast",
                "nucleic-acid-purification",
                "genomic-dna"
            ],
            "filters": []
        },
        "Quick-DNA Fungal/Bacterial Microprep Kit": {
            "title": "Quick-DNA Fungal/Bacterial Microprep Kit",
            "catalogNumbers": "D6007",
            "description": "The Quick-DNA Fungal/Bacterial Microprep Kit is designed for the simple and rapid isolation of DNA from tough-to-lyse fungi, including A. fumigatus, C. albicans, N. crassa, S. cerevisiae, S. pombe, as well as Gram (+/-) bacteria, algae, and protozoa.",
            "handle": "/collections/quick-dna-fungal-bacterial-kits/products/quick-dna-fungal-bacterial-microprep-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6007_Quick-DNA-Fungal-Bacterial-Microprep-Kit.jpg?v=1628532403&width=600",
            "generalIndex": "998",
            "id": "quick-dna-fungal-bacterial-microprep-kit",
            "tags": [
                "yeast",
                "nucleic-acid-purification",
                "genomic-dna",
                "quick-dna-fungal-bacterial-kits"
            ],
            "filters": []
        },
        "Quick-DNA Fungal/Bacterial Miniprep Kit": {
            "title": "Quick-DNA Fungal/Bacterial Miniprep Kit",
            "catalogNumbers": "D6005",
            "description": "The Quick-DNA Fungal/Bacterial Miniprep Kit is designed for the simple and rapid isolation of DNA from tough-to-lyse fungi, including A. fumigatus, C. albicans, N. crassa, S. cerevisiae, S. pombe, as well as Gram (+/-) bacteria, algae, and protozoa.",
            "handle": "/collections/quick-dna-fungal-bacterial-kits/products/quick-dna-fungal-bacterial-miniprep-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6005_Quick-DNA-Fungal-Bacterial-Miniprep-Kit.jpg?v=1628532400&width=600",
            "generalIndex": "998",
            "id": "quick-dna-fungal-bacterial-miniprep-kit",
            "tags": [
                "yeast",
                "nucleic-acid-purification",
                "genomic-dna",
                "quick-dna-fungal-bacterial-kits"
            ],
            "filters": []
        },
        "Quick-DNA Fungal/Bacterial Midiprep Kit": {
            "title": "Quick-DNA Fungal/Bacterial Midiprep Kit",
            "catalogNumbers": "D6105",
            "description": "The Quick-DNA Fungal/Bacterial Midiprep Kit is designed for the simple and rapid isolation of DNA from tough-to-lyse fungi, including A. fumigatus, C. albicans, N. crassa, S. cerevisiae, S. pombe, as well as Gram (+/-) bacteria, algae, and protozoa.",
            "handle": "/collections/quick-dna-fungal-bacterial-kits/products/quick-dna-fungal-bacterial-midiprep-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6105_Quick-DNA-Fungal-Bacterial-Midiprep-Kit.jpg?v=1628532391&width=600",
            "generalIndex": "998",
            "id": "quick-dna-fungal-bacterial-midiprep-kit",
            "tags": [
                "yeast",
                "nucleic-acid-purification",
                "genomic-dna",
                "quick-dna-fungal-bacterial-kits"
            ],
            "filters": []
        },
        "Quick-DNA Fungal/Bacterial 96 Kit": {
            "title": "Quick-DNA Fungal/Bacterial 96 Kit",
            "catalogNumbers": "D6006",
            "description": "The Quick-DNA Fungal/Bacterial 96 Kit is designed for the simple and rapid isolation of DNA from tough-to-lyse fungi, including A. fumigatus, C. albicans, N. crassa, S. cerevisiae, S. pombe, as well as Gram (+/-) bacteria, algae, and protozoa.",
            "handle": "/collections/quick-dna-fungal-bacterial-kits/products/quick-dna-fungal-bacterial-96-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6006_Quick-DNA-Fungal-Bacterial-96-Kit.jpg?v=1628532390&width=600",
            "generalIndex": "998",
            "id": "quick-dna-fungal-bacterial-96-kit",
            "tags": [
                "yeast",
                "nucleic-acid-purification",
                "genomic-dna",
                "quick-dna-fungal-bacterial-kits"
            ],
            "filters": []
        },
        "YeaStar RNA Kit": {
            "title": "YeaStar RNA Kit",
            "catalogNumbers": "R1002",
            "description": "Simple spin-column solution for isolating RNA from yeast using Zymolyase.",
            "handle": "/products/yeastar-rna-kit",
            "navigation_image": "yeast",
            "generalIndex": "998",
            "id": "yeastar-rna-kit",
            "tags": [
                "yeast",
                "nucleic-acid-purification"
            ],
            "filters": []
        },
        "Quick-RNA Fungal/Bacterial Microprep Kit": {
            "title": "Quick-RNA Fungal/Bacterial Microprep Kit",
            "catalogNumbers": "R2010",
            "description": "Designed for the simple and rapid isolation of RNA from tough-to-lyse fungi, up to 10 µg (per prep)",
            "handle": "/products/quick-rna-fungal-bacterial-microprep-kit",
            "navigation_image": "fungal_bacterial",
            "generalIndex": "998",
            "id": "quick-rna-fungal-bacterial-microprep-kit",
            "tags": [
                "yeast",
                "nucleic-acid-purification"
            ],
            "filters": []
        },
        "Quick-RNA Fungal/Bacterial Miniprep Kit": {
            "title": "Quick-RNA Fungal/Bacterial Miniprep Kit",
            "catalogNumbers": "R2014",
            "description": "Designed for the simple and rapid isolation of RNA from tough-to-lyse fungi, up to 50 µg (per prep)",
            "handle": "/products/quick-rna-fungal-bacterial-miniprep-kit",
            "navigation_image": "fungal_bacterial",
            "generalIndex": "998",
            "id": "quick-rna-fungal-bacterial-miniprep-kit",
            "tags": [
                "yeast",
                "nucleic-acid-purification"
            ],
            "filters": []
        },
        "Yeast Protein Kit": {
            "title": "Yeast Protein Kit",
            "catalogNumbers": "Y1002",
            "description": "The Yeast Protein Kit is a simple and convenient method for the rapid and thorough lysis of yeast cells.",
            "handle": "/products/yeast-protein-kit",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/Y1002_Yeast-Protein-Kit_215fe0f5-a528-45d4-9e60-5c0ffc0a05ca.jpg?v=1628532367&width=600",
            "generalIndex": "998",
            "id": "yeast-protein-kit",
            "tags": [
                "yeast",
                "yeast-reagents-and-enzymes"
            ],
            "filters": []
        },
        "YPD Plus": {
            "title": "YPD Plus",
            "catalogNumbers": "Y1003-100, Y1003-50",
            "description": "The outgrowth step in yeast transformation protocols is often critical for increasing overall yeast transformation efficiencies.",
            "handle": "/products/ypd-plus",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/Y1003-50-YPD-Plus.jpg?v=1628532387&width=600",
            "generalIndex": "998",
            "id": "ypd-plus",
            "tags": [
                "yeast",
                "yeast-transformation",
                "yeast-reagents-and-enzymes"
            ],
            "filters": []
        },
        "Alpha-Factor Mating Pheromone": {
            "title": "Alpha-Factor Mating Pheromone",
            "catalogNumbers": "Y1001",
            "description": "When yeast \"a\" and \"alpha\" cells encounter mating pheromones of the opposite cell type they induce genes necessary for mating, arrest the cell cycle in G1, alter cell surface and nuclear determinants, and also undergo dramatic morphological elongation into pear shapes, affectionately termed \"schmooing\".",
            "handle": "/products/alpha-factor-mating-pheromone",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/Y1001_Alpha-Factor-Mating-Pheromone_e8f8181c-051f-4871-9192-e3c333441e84.jpg?v=1628532366&width=600",
            "generalIndex": "998",
            "id": "alpha-factor-mating-pheromone",
            "tags": [
                "yeast",
                "yeast-reagents-and-enzymes",
                "yeast-mating-pheromones"
            ],
            "filters": []
        },
        "a-Factor Mating Pheromone": {
            "title": "a-Factor Mating Pheromone",
            "catalogNumbers": "Y1004-500",
            "description": "When yeast \"a\" and \"alpha\" cells encounter mating pheromones of the opposite cell type they induce genes necessary for mating, arrest the cell cycle in G1, alter cell surface and nuclear determinants, and also undergo dramatic morphological elongation into pear shapes, affectionately termed \"schmooing\".",
            "handle": "/products/a-factor-mating-pheromone",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/Y1004_a-Factor-Mating-Pheromone-A-Factor-500-ul_3c218c2c-83f9-49dc-8c8f-3e0a3b041711.jpg?v=1628532354&width=600",
            "generalIndex": "998",
            "id": "a-factor-mating-pheromone",
            "tags": [
                "yeast",
                "yeast-reagents-and-enzymes",
                "yeast-mating-pheromones"
            ],
            "filters": []
        },
        "5-Fluoroorotic Acid (5-FOA)": {
            "title": "5-Fluoroorotic Acid (5-FOA)",
            "catalogNumbers": "F9001-1, F9001-5, F9003",
            "description": "Using 5-Fluoroorotic Acid (5-FOA) for the counter-selection of yeast is a common genetic screening method.",
            "handle": "/products/5-fluoroorotic-acid",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/F9001-1_5-Fluoroorotic-Acid-1-g_f35b2afb-1fd8-415e-955a-8a76343c4571.jpg?v=1628532364&width=600",
            "generalIndex": "998",
            "id": "5-fluoroorotic-acid",
            "tags": [
                "yeast",
                "yeast-reagents-and-enzymes"
            ],
            "filters": []
        },
        "Frozen-EZ Yeast Solution": {
            "title": "Frozen-EZ Yeast Solution",
            "catalogNumbers": "T2002, T2003, T2004",
            "description": "Buffer components of the Frozen-EZ Yeast Transformation II Kit (T2001).",
            "handle": "/products/frozen-ez-yeast-solution",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T2002_Frozen-EZ-Solution-1_3f791881-30d1-4d6f-8d13-60dcc00f4f82.jpg?v=1628532374&width=600",
            "generalIndex": "998",
            "id": "frozen-ez-yeast-solution",
            "tags": [
                "yeast"
            ],
            "filters": []
        }
    }
}